import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import BrandMark from '../components/BrandMark';
import brandStyles from '../styles/BrandMark.module.css';
import useAuthPageBackground from '../hooks/useAuthPageBackground';
import styles from '../styles/LoginPage.module.css';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login, error: authError } = useContext(AuthContext);
  const navigate = useNavigate();
  useAuthPageBackground();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const result = await login({ username, password });
      if (result.passwordResetRequired) {
        navigate('/reset-password');
      } else {
        navigate('/');
      }
    } catch (err) {
      console.error('Login error:', err);
      // The error is now handled by Redux and available in authError
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.formWrapper}>
        <BrandMark
          size={56}
          showText
          className={`${brandStyles.centered} ${brandStyles.authMark}`}
        />
        <h1 className={styles.title}>Welcome Back</h1>
        <p className={styles.subtitle}>Sign in to access your account</p>

        {authError && <div className={styles.errorMessage}>{authError}</div>}

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className={styles.input}
              disabled={isLoading}
              autoComplete="username"
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className={styles.input}
              disabled={isLoading}
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className={styles.primaryButton}
            disabled={isLoading}
          >
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className={styles.formFooter}>
          <p>Need an account? Ask a commissioner for an invite.</p>
          <p className={styles.forgotPassword}>
            <Link to="/forgot-password" className={styles.link}>Forgot your password?</Link>
          </p>
          <p className={styles.legalLinks}>
            <Link to="/sms-opt-in" className={styles.link}>SMS Opt-In</Link>
            {' · '}
            <Link to="/privacy" className={styles.link}>Privacy</Link>
            {' · '}
            <Link to="/terms" className={styles.link}>Terms</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
